import React, { useEffect, createElement } from 'react';
import { useLanguage } from '../hooks/useLanguage';
type SEOProps = {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
};
export function SEO({
  title,
  description,
  keywords,
  image = 'https://cdn.magicpatterns.com/uploads/t37N25GpwJa9GYRmF4gvMx/1.png',
  url = 'https://kratomborneo.id'
}: SEOProps) {
  const {
    language
  } = useLanguage();
  const defaultTitles = {
    en: 'KBIN - Premium Indonesian Kratom | Export Quality Kratom Products',
    zh: 'KBIN - 优质印尼卡痛叶 | 出口级卡痛叶产品',
    id: 'KBIN - Kratom Premium Indonesia | Produk Kratom Kualitas Ekspor'
  };
  const defaultDescriptions = {
    en: 'PT Kratom Borneo Indonesia (KBIN) - Professional trading, processing, and distribution of premium Indonesian kratom. Export-standard quality, sustainable sourcing, full compliance with international regulations. Contact: +62 82275757589',
    zh: '印尼婆罗洲卡痛叶公司（KBIN）- 专业的优质印尼卡痛叶贸易、加工和分销。出口标准质量，可持续采购，完全符合国际法规。联系方式：+62 82275757589',
    id: 'PT Kratom Borneo Indonesia (KBIN) - Perdagangan, pengolahan, dan distribusi kratom premium Indonesia secara profesional. Kualitas standar ekspor, sumber berkelanjutan, kepatuhan penuh terhadap regulasi internasional. Kontak: +62 82275757589'
  };
  const defaultKeywords = {
    en: 'kratom indonesia, indonesian kratom, kratom export, premium kratom, kratom supplier, kratom wholesale, kratom borneo, mitragyna speciosa, kratom powder, dried kratom leaves, kratom distributor, export quality kratom, sustainable kratom, legal kratom trade, KBIN',
    zh: '印尼卡痛叶, 卡痛叶出口, 优质卡痛叶, 卡痛叶供应商, 卡痛叶批发, 婆罗洲卡痛叶, 卡痛叶粉, 干卡痛叶, 卡痛叶分销商, 出口级卡痛叶, 可持续卡痛叶, 合法卡痛叶贸易',
    id: 'kratom indonesia, kratom borneo, ekspor kratom, kratom premium, supplier kratom, grosir kratom, mitragyna speciosa, bubuk kratom, daun kratom kering, distributor kratom, kratom kualitas ekspor, kratom berkelanjutan, perdagangan kratom legal, KBIN'
  };
  const pageTitle = title || defaultTitles[language];
  const pageDescription = description || defaultDescriptions[language];
  const pageKeywords = keywords || defaultKeywords[language];
  useEffect(() => {
    // Set document title
    document.title = pageTitle;
    // Set or update meta tags
    const setMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    // Basic meta tags
    setMetaTag('description', pageDescription);
    setMetaTag('keywords', pageKeywords);
    setMetaTag('author', 'PT Kratom Borneo Indonesia');
    setMetaTag('robots', 'index, follow');
    setMetaTag('language', language === 'zh' ? 'zh-CN' : language === 'id' ? 'id-ID' : 'en-US');
    // Open Graph meta tags (for Facebook, LinkedIn, etc.)
    setMetaTag('og:title', pageTitle, true);
    setMetaTag('og:description', pageDescription, true);
    setMetaTag('og:image', image, true);
    setMetaTag('og:url', url, true);
    setMetaTag('og:type', 'website', true);
    setMetaTag('og:site_name', 'KBIN - PT Kratom Borneo Indonesia', true);
    setMetaTag('og:locale', language === 'zh' ? 'zh_CN' : language === 'id' ? 'id_ID' : 'en_US', true);
    // Twitter Card meta tags
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', pageTitle);
    setMetaTag('twitter:description', pageDescription);
    setMetaTag('twitter:image', image);
    // Additional SEO tags
    setMetaTag('theme-color', '#047857'); // emerald-700
    setMetaTag('viewport', 'width=device-width, initial-scale=1.0');
    // Canonical link
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;
    // Alternate language links
    const setAlternateLink = (lang: string, href: string) => {
      let link = document.querySelector(`link[hreflang="${lang}"]`) as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'alternate';
        link.hreflang = lang;
        document.head.appendChild(link);
      }
      link.href = href;
    };
    setAlternateLink('en', url);
    setAlternateLink('zh', url);
    setAlternateLink('id', url);
    setAlternateLink('x-default', url);
  }, [pageTitle, pageDescription, pageKeywords, image, url, language]);
  return null;
}